import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMyContext } from '../../context/MyContext';

const PrivateRoute = ({ children, allowedRoles }) => {
    const { user } = useMyContext();
    const location = useLocation();

    if (!user) {
        // Redirect to the login page if not authenticated
        return <Navigate to="/" state={{ from: location }} />;
    }

    if (!allowedRoles.includes(user.role)) {
        // Redirect to a not authorized page or home page if the role is not allowed
        return <Navigate to="/not-authorized" />;
    }

    // Render the children components (the protected route)
    return children;
};

export default PrivateRoute;
